import { useTranslate } from "@/common/hooks/useTranslate";

export const useBuildPrefilledDescription = () => {
  const { t } = useTranslate();

  const buildPrefilledDescription = ({
    organizationName,
    isPeerToPeerCampaign,
  }: {
    organizationName: string;
    isPeerToPeerCampaign: boolean;
  }) => {
    const boldOrgName = `<strong>${organizationName}</strong>`;
    return `
      🌟 ${t("dashboard", "donationForm.prefilledDescription1")} 🌟<br />${t("dashboard", "donationForm.prefilledDescription2", { boldOrgName })}
      <br /><br /><strong>${t("dashboard", "donationForm.prefilledDescription3")}</strong>
      <ol>
      <li>${t("dashboard", "donationForm.prefilledDescription4")}</li>
      ${
        isPeerToPeerCampaign
          ? `<li>${t("dashboard", "donationForm.prefilledFundraisingCampaignDescription1")}</li>
      <li>${t("dashboard", "donationForm.prefilledFundraisingCampaignDescription2")}</li>`
          : `<li>${t("dashboard", "donationForm.prefilledDescription5")}</li>`
      }
      <li>${t("dashboard", "donationForm.prefilledDescription6")}</li>
      </ol>
      <p>${t("dashboard", "donationForm.prefilledDescription7")}</p>
      `;
  };

  return { buildPrefilledDescription };
};
